import styled from 'styled-components';

export const TabsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 24px;
`;

export const TabButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 6px 0 12px;
  border: 0;
  border-bottom: 2px solid ${({ theme, $active }) => ($active ? theme.borders.workspaceSelectedItem : 'transparent')};
  background: transparent;
  color: ${({ theme, $active }) => ($active ? theme.text.plannerTabActive : theme.text.actionBar)};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  line-height: 1.45;
  cursor: pointer;
`;

export const TabIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
  }

  svg path {
    fill: ${({ theme, $active }) => ($active ? theme.borders.workspaceSelectedItem : theme.text.detailModalTabs)};
  }
`;

export const TabLabel = styled.span`
  color: ${({ theme, $active }) => ($active ? theme.borders.workspaceSelectedItem : theme.text.detailModalTabs)};
  white-space: nowrap;
`;
